var map = {
	"./clickCallMobile.svg": 3255,
	"./hotMobile.png": 7633,
	"./hot_mobile.png": 3224,
	"./log-out.svg": 3319,
	"./logo.svg": 9574,
	"./partner.png": 7815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6041;